import React from "react";
import AutoComplete from "../utility/auto-complete";
import MessageBox from "../../components/utility/message-box";
import update from 'immutability-helper';
export default class EmployeeShortage extends React.Component {
    constructor() {
        super();
        this.state = {
            onSelectEmployeeList: [],
            totalShortage: 0
        };
        this.messageBox = null;
    }
    onEmployeeSelect(emp) {
        if (emp) {
            emp.amount = 0;
            var exist;
            this.state.onSelectEmployeeList.forEach((employee) => {
                if (employee.employeeId === emp.employeeId) {
                    exist = true;
                    this.searchBox.value = "";
                }
            });
            if (!exist) {
                this.state.onSelectEmployeeList.push(emp);
                this.searchBox.value = "";
                this.setState(this.state);
            }


        }
    }
    getTotal() {
        var totalAmount = 0;
        this.state.onSelectEmployeeList.forEach((employee) => {
            totalAmount += employee.amount;
        });
        this.state.totalShortage = totalAmount;
        return totalAmount;
    }
    updateShortage(i, e) {
        // this.state.onSelectEmployeeList[i].amount 
        const amount = parseFloat(e.target.value) ? parseFloat(e.target.value) : 0;
        // console.log("--", this.state.onSelectEmployeeList);
        var onSelectEmployeeList = update(this.state.onSelectEmployeeList, { [i]: { amount: { $set: amount } } });
        //  this.state.totalShortage = this.getTotal();
        this.setState({ onSelectEmployeeList });
        // this.setState({ onSelectEmployeeList });
        //console.log(e.target.value);
        //console.log(onSelectEmployeeList);
    }
    DeleteMe(i) {
        // console.log(this.state.onSelectEmployeeList.length);
        this.state.onSelectEmployeeList.splice(i, 1);
        //this.state.totalShortage = this.getTotal();
        this.setState({});
        // console.log(this.state.onSelectEmployeeList);
    }
    onCancle() {
        this.props.onCancle();
        this.setState(this.state);
    }
    onSave() {
        //console.log("______");
        if (this.props.shortageAmount !== undefined) {
            if (this.state.totalShortage === this.props.shortageAmount) {
                this.props.onSave(this.state.onSelectEmployeeList);
            } else {
                this.messageBox = MessageBox.showMessage(`Total shortage amount must be ${this.props.shortageAmount}`, false, this);
            }
        } else {
            this.messageBox = MessageBox.showMessage("please enter last collection amount first", false, this);
        }
        this.setState(this.state);
    }

    componentWillReceiveProps(nextProps) {
        //console.log("component will receive props fired", this.props, nextProps);
        // console.log("willreceive prop fired", nextProps);
        if (nextProps.reset) {
            this.state = {
                onSelectEmployeeList: [],
                totalShortage: 0
            };
        }
    }
    componentDidMount() {
        this.searchBox.focus();
    }
    render() {
        //console.log("rend", this.state.onSelectEmployeeList);
        return (
            <div style={{ display: this.props.display ? "block" : "none" }}>
                <div className="overlay" onClick={this.onCancle.bind(this)}></div>
                <div id="employeeShortage">
                    <h2 style={{ textAlign: "center", color: "gray", marginTop: "20px" }}> Total Shortage Amount {this.props.shortageAmount}</h2>
                    <br />
                    <p className="formMsg">Employee Shortage</p>
                    <div style={{ marginLeft: "40px" }}>
                        <p className="label">Select a Employee</p>
                        <AutoComplete
                            placeholder="select an employee"
                            dataSrc="api/v1/employee/auto"
                            dataTobind="employeeName"
                            keyToBind="employeeId"
                            tabIndex="1"
                            onSelect={this.onEmployeeSelect.bind(this)}
                            clearStyle={{ right: "90px" }}
                            rex={(searchBox) => {
                                this.searchBox = searchBox;
                                //this.searchBox.onfocus = this.onSelectEmployeeFocus.bind(this);
                            }}
                        />
                        {this.state.onSelectEmployeeList.length >= 1 ? <table className="clear borderless" style={{ minWidth: "340px" }}>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Amount</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.onSelectEmployeeList.map((e, i) => {
                                    return (
                                        <tr key={e.employeeId} style={{ textAlign: "center" }}>
                                            <td>{e.employeeName}</td>
                                            <td>
                                                <input
                                                    type="text"
                                                    onChange={this.updateShortage.bind(this, i)}
                                                    style={{ color: "gray", textAlign: "center", outline: "none", border: "none", borderBottom: "1px solid lightgray" }} />
                                            </td>
                                            <td onClick={this.DeleteMe.bind(this, i)}>
                                                <i style={{ color: "gray", fontSize: "16px", cursor: "pointer" }} className="fa fa-trash" aria-hidden="true"></i>
                                            </td>
                                        </tr>
                                    );
                                })}
                                <tr>
                                    <td style={{ color: "#bf1f1f" }}>Total</td>
                                    <td className="center" style={{ color: "#bf1f1f" }}>{this.getTotal()}</td>
                                </tr>


                            </tbody>
                        </table> : null}

                    </div>


                    <div>
                        <button className="btn btnOk btnRight" style={{ marginRight: "20px" }} onClick={this.onSave.bind(this)} >Save</button>

                        <button className="btn btnOk btnRight" style={{ marginRight: "10px" }} onClick={this.onCancle.bind(this)}>Cancle</button>
                    </div>
                    {this.messageBox}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/jsx/components/fragments/employee-shortage.jsx